const codeBlocks = {
	'tabs-cb': (rdm, rcm)=> {return `
<div class="rwx-tabs" id="{{ UNIQUE ID }}" role="tablist" rwx-tabs>
	<div class="rwx-tabs-tab" data-rwx-tabs-title="{{ TAB TITLE }}" role="tabpanel">
		{{ TAB CONTENT}}
	</div>
	<div class="rwx-tabs-tab" data-rwx-tabs-title="{{ TAB TITLE }}" role="tabpanel">
		{{ TAB CONTENT }}
	</div>
</div>
	`},
	'slider-cb': (rdm, rcm)=> {return `
<div class="rwx-slider ${rcm || ''}" id="{{ UNIQUE ID }}" rwx-slider ${rdm || ''}>
	<div class="rwx-slider-slide"> 
		{{ SLIDE CONTENT }} 
	</div>
	<div class="rwx-slider-slide"> 
		{{ SLIDE CONTENT }} 
	</div>
</div>
	`},
	'form-cb': (rdm,rcm)=> {return `
<form class="rwx-form" id="{{ UNIQUE ID }}" rwx-form>{{ FORM ITEMS }}</form>
	`},
	'form-item-readonly-cb': (rdm, rcm)=> {return codeBlocks['form-item-cb'](rdm,rcm,true)},
	'form-item-cb': (rdm, rcm, readonly=false)=> {return `
<div class="rwx-form-item ${rcm || ''}"${readonly ? " readonly":''}>
	<input type="${rdm || ''}" name="{{ NAME OF FIELD }}" id="{{ UNIQUE ID }}" />
	<label for="{{ SAME ID AS INPUT }}">{{ LABEL TEXT }}</label>
	<p class="invalid-message">{{ INVALID MESSAGE TEXT }}</p>
</div>
	`},
	'form-dropdown-cb': (rdm, rcm)=> {return `
<div class="rwx-form-item ${rcm || ''}">
	<select name="{{ NAME OF FIELD }}" id="{{ UNIQUE ID }}">
		<option value="{{ OPTION VALUE }}">{{ OPTION TEXT }}</option>
		<option value="{{ OPTION VALUE }}">{{ OPTION TEXT }}</option>
		<option value="{{ OPTION VALUE }}">{{ OPTION TEXT }}</option>
	</select>
	<label for="{{ SAME ID AS SELECT}}">{{ LABEL TEXT }}</label>
</div>
	`},
	'form-radio-group-cb': (rdm, rcm)=> {return `
<div class="rwx-form-radio-group ${rcm || ''}" id="{{ UNIQUE ID }}}">
	<p>{{ RADIO GROUP LABEL TEXT }}</p>
	<div class="rwx-form-item">
		<input type="radio" name="{{ SAME NAME AS OTHER RADIO ITEMS IN SAME RADIO GROUP }}" id="{{ UNIQUE ID }}" />
		<label for="{{ SAME ID AS INPUT }}">{{ RADIO GROUP ITEM LABEL TEXT }}</label>
	</div>
	<div class="rwx-form-item">
		<input type="radio" name="{{ SAME NAME AS OTHER RADIO ITEMS IN SAME RADIO GROUP }}" id="{{ UNIQUE ID }}" />
		<label for="{{ SAME ID AS INPUT }}">{{ RADIO GROUP ITEM LABEL TEXT }}</label>
	</div>
	<div class="rwx-form-item">
		<input type="radio" name="{{ SAME NAME AS OTHER RADIO ITEMS IN SAME RADIO GROUP }}" id="{{ UNIQUE ID }}" />
		<label for="{{ SAME ID AS INPUT }}">{{ RADIO GROUP ITEM LABEL TEXT }}</label>
	</div>
</div>
	`},
	'form-textarea-cb': (rdm, rcm)=> {return `
<div class="rwx-form-item">
	<textarea name="{{ NAME OF FIELD }}" id="{{ UNIQUE ID }}" rows="{{ HOW MANY ROWS OF TEXT }}"/>
	<label for="{{ SAME ID AS TEXTAREA }}">{{ LABEL TEXT }}</label>
	<p class="invalid-message">{{ INVALID MESSAGE TEXT }}</p>
</div>
	`},
	'form-submit-button-cb': (rdm, rcm)=> {return `
<button type="submit">{{ SUBMIT FORM TEXT }}</button>
	`},
	'table-cb': (rdm, rcm, x2=false, x3=false)=> { return `
<div class="rwx-table ${rcm || ''}" role="table" rwx-table>
	<div class="rwx-table-data" role="row">
		<span role="cell">{{ TABLE DATA TEXT }}</span>
		<span role="cell" ${x2 ? 'class="x2"' : ''}${x3 ? 'class="x3"' : ''}>{{ TABLE DATA TEXT }}</span>
	</div>
	<div class="rwx-table-data" role="row">
		<span role="cell">{{ TABLE DATA TEXT }}</span>
		<span role="cell" ${x2 ? 'class="x2"' : ''}${x3 ? 'class="x3"' : ''}>{{ TABLE DATA TEXT }}</span>
	</div>
	<div class="rwx-table-data" role="row">
		<span role="cell">{{ TABLE DATA TEXT }}</span>
		<span role="cell" ${x2 ? 'class="x2"' : ''}${x3 ? 'class="x3"' : ''}>{{ TABLE DATA TEXT }}</span>
	</div>	
</div>
	`},
	'table-x2-cb': (rdm, rcm)=> { return codeBlocks['table-cb'](rdm,rcm,true)},
	'table-x3-cb': (rdm, rcm)=> { return codeBlocks['table-cb'](rdm,rcm,false,true)},
	'slideshow-cb': (rdm, rcm) => {return `
<div class="rwx-slideshow" rwx-slideshow>
  <div class="slide">
    <h1 class="slide-title">Slide One</h1>
    <div class="slide-content">
      <ul>
        <li>Point 1</li>
        <li>Point 2</li>
        <li>Point 3</li>
      </ul>
    </div>
  </div>
  <div class="slide">
    <h1 class="slide-title">Slide Two</h1>
    <div class="slide-content">
      <ul>
        <li>Point 1</li>
        <li>Point 2</li>
        <li>Point 3</li>
      </ul>
    </div>
  </div> 
</div>
	`},
	'phototile-cb': (rdm, rcm) => { return `
<div class="rwx-phototile" id="{{ UNIQUE ID }}" rwx-photoTile ${rdm || ''}>
  <img role="button" src="{{IMAGE SRC}}" alt="Random Demonstration Image" />
  <img role="button" src="{{IMAGE SRC}}" alt="Random Demonstration Image" />
  <div role="button" class="rwxc-background-brown"></div>
  <img role="button" src="{{IMAGE SRC}}" alt="Random Demonstration Image" />
  <img role="button" src="{{IMAGE SRC}}" alt="Random Demonstration Image" />
  <div role="button" class="rwxc-background-light-green"></div>	
</div>
	`},
	'grid-gallery-cb': (rdm, rcm) => { return `
<div class="rwx-grid-gallery" rwx-grid-gallery>
	<a class="rwx-grid-gallery-item no-decoration" href="{{ LINK }}" target="_blank">
	  <h3 class="rwx-grid-gallery-heading">{{ HEADING }}</h3>
	  <div role="img" class="rwx-grid-gallery-overlay" style="background-image: url('{{ BACKGROUND IMAGE URL }}');"></div>
	</a>
	<a class="rwx-grid-gallery-item no-decoration" href="{{ LINK }}" target="_blank">
	  <h3 class="rwx-grid-gallery-heading">{{ HEADING }}</h3>
	  <div role="img" class="rwx-grid-gallery-overlay" style="background-image: url('{{ BACKGROUND IMAGE URL }}');"></div>
	</a>
	<a class="rwx-grid-gallery-item no-decoration" href="{{ LINK }}" target="_blank">
	  <h3 class="rwx-grid-gallery-heading">{{ HEADING }}</h3>
	  <div role="img" class="rwx-grid-gallery-overlay" style="background-image: url('{{ BACKGROUND IMAGE URL }}');"></div>
	</a>
</div>
	`},
	'countometer-cb': (rdm, rcm) => { return `
<div rwx-countometer data-rwx-countometer-value="{{ VALUE }}"></div>
	`}
}

export default codeBlocks;